import script from "./BillingDataPaidAppStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingDataPaidAppStore.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__